import { useState } from 'react';
import api from '@/utils/api';
import { toaster } from '@/components/ui/toaster';

interface AIContentRequestData {
  workspace_id: number;
  country: string;
  content_type_id: number;
  name: string;
  description: string;
  assistant_name?: string;
}

interface UseAIContentRequestsReturn {
  createAIContentRequests: (requests: AIContentRequestData[]) => Promise<boolean>;
  isLoading: boolean;
  error: string | null;
}

export default function useAIContentRequests(): UseAIContentRequestsReturn {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createAIContentRequests = async (requests: AIContentRequestData[]): Promise<boolean> => {
    setIsLoading(true);
    setError(null);
    
    try {
      // Create each AI content request
      const createPromises = requests.map(request => 
        api.post(`/ai-content-requests`, request)
      );
      
      await Promise.all(createPromises);
      
      toaster.create({
        title: 'AI content requests created successfully',
        type: 'success',
        duration: 3000,
      });
      
      return true;
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || 'Failed to create AI content requests';
      setError(errorMessage);
      
      toaster.create({
        title: errorMessage,
        type: 'error',
        duration: 3000,
      });
      
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    createAIContentRequests,
    isLoading,
    error,
  };
}
